import type { TCascadeApi } from '@cascade/api-client/cascade-api';
import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ApiContext } from '#providers/api/Api.context.ts';

export const useApi = (): TCascadeApi =>
  useRequiredContext(
    ApiContext,
    'useApi is only available inside an ApiProvider',
  );
